import dayjs from 'dayjs'
import { qcopy, deepClone, isHighGlu, isLowGlu, isNormalGlu, findObjIndexInArray, padZero } from '@u'
import { derror, error } from '@u/log'
import { _getPumpBasalFromRecords } from './reportHelper'
import { _getMergedPumpBigDosageFromRecords, _getPumpBigDosageFromRecords } from '@u/reportHelper'
import { _transferBGData, _transferYHeightToBGValue } from '@u/reportHelperBG'

export const labelSize = 18
export function _transferBasalData(v) { // 需要修改; y轴 0->5
  if (Number.isNaN(+v)) {
    console.error(`_transferBasalData入参v不是合法数字: ${v}`)
  }
  // 改变此逻辑，要相应改变坐标轴label的formatter
  const ymin = 0 // 改变ymin或ymax,要相应改变下面的yranges
  const ymax = 5 // 改变ymin或ymax,要相应改变下面的yranges.还需要更改_heightEquilToBigDosageV里头的变量basalYmax; 这个ymax是因为echarts里头设置了y轴为0->5(实际上是0->5.5，从而为表格上部留了0.5的空白)
  // const ranges = [[0, 1], [1, 2], [2, 3], [3, 5.001]]
  // const _rangesWidth = [1.5, 1.5, 6, 1]
  const ranges = [[0, 2.5], [2.5, 7.001]] // 实际上的临时基础率值泵pda最大能操作到6.975
  const _rangesWidth = [5, 5]
  const _rangesWidthSum = _rangesWidth.reduce((prev, cur) => {
    return cur + prev
  }, 0)
  const rangesWidth = _rangesWidth.map(v => ymax * v / _rangesWidthSum)
  const rangesWidthSum = rangesWidth.reduce((prev, cur) => {
    return cur + prev
  }, 0)  
  const yranges = rangesWidth.map((v, i) => {
    if (i === 0) {
      return 0
    } else {
      const l = rangesWidth.length
      const rest = l - i - 1
      
      let sumAfterIIncludingI = 0      
      for (let j = 0; j <= rest; j++) {
        sumAfterIIncludingI += (rangesWidth[j + i])
      }
      
      return rangesWidthSum - sumAfterIIncludingI
    }
  })
  
  const origin = +v
  const max = ranges[ranges.length - 1][1] // 5
  const min = ranges[0][0] // 0
  const rst = v
  
  if (Number.isNaN(origin)) {
    console.error(`[_transferBigDosageBarData]柱形图转换数据,输入的数据是非法数字v: ${v};为了逻辑不崩，直接return v`)
    return v
  }
  
  const i = _whatRangeIndex(origin)
  
  if (i < 0) {
    if (origin - min < 0) {
      return ymin
    }
    if (origin - max > 0) {
      return ymax
    }
    console.error(`[_transferBigDosageBarData]数据v: ${v},不再范围 ${min}~${max}之间`)
  } else {
    const rs = ranges[i]
    const rsGap = rs[1] - rs[0]
    const rw = rangesWidth[i]
    const min = rs[0]
    
    const gap = origin - min
    
    const rst = +yranges[i] + (gap / rsGap) * rw
    
    return +((+rst).toFixed(3))
  }
  
  return +((+rst).toFixed(3))
  
  function _whatRangeIndex(v) {
    let index = -1
    ranges.forEach((range, i) => {
      const min = range[0]
      const max = range[1]
      if (v - min >= 0 && v - max < 0) {
        index = i
      }
    })
    return index
  }
}

// 改变此逻辑，要相应改变坐标轴label的formatter
const ymin = 0 // 改变ymin或ymax,要相应改变下面的yranges
const ymax = 10 // 改变ymin或ymax,要相应改变下面的yranges
const count = 10 // 10等分,3个range
// const ranges = [[0, 5], [5, 10], [10, 25.001]]
// const _rangesWidth = [3, 3, 4] // 分别占据3/10, 6/10,1/10
const ranges = [[0, 5], [5, 25.001]]
const _rangesWidth = [5, 5]
const _rangesWidthSum = _rangesWidth.reduce((prev, cur) => {
  return cur + prev
}, 0)
const rangesWidth = _rangesWidth.map(v => ymax * v / _rangesWidthSum)
const rangesWidthSum = rangesWidth.reduce((prev, cur) => {
  return cur + prev
}, 0)  
const yranges = rangesWidth.map((v, i) => {
  if (i === 0) {
    return 0
  } else {
    const l = rangesWidth.length
    const rest = l - i - 1
    
    let sumAfterIIncludingI = 0      
    for (let j = 0; j <= rest; j++) {
      sumAfterIIncludingI += (rangesWidth[j + i])
    }
    
    return rangesWidthSum - sumAfterIIncludingI
  }
})
function _whatRangeIndex(v) {
  let index = -1
  ranges.forEach((range, i) => {
    const min = range[0]
    const max = range[1]
    if (v - min >= 0 && v - max < 0) {
      index = i
    }
  })
  return index
}

function _whatRangeWidthIndex(h) {
  let index = -1
  for (let i = 0; i < yranges.length; i++) {
    const next = yranges[i + 1]
    const limit = yranges[i]
    if (next !== undefined) {
      if (h - limit > 0 && h - next <= 0) {
        index = i
        break
      }
    } else {
      index = i
      break
    }    
  }
  return index
}
export function _transferBigDosageBarData(v, extra = {}) { // 需要修改; y轴 0->10
  const { _trueV, _basalHeight } = extra
  // console.error(`[_transferBigDosageBarData]big dosage height(v): ${v}, _trueV: ${_trueV}, _basalHeight: ${_basalHeight}, extra: `, extra)
  const origin = +v
  const max = ranges[ranges.length - 1][1] // 25
  const min = ranges[0][0] // 0
  const rst = v
  
  if (Number.isNaN(origin)) {
    console.error(`[_transferBigDosageBarData]柱形图转换数据,输入的数据是非法数字v: ${v};为了逻辑不崩，直接return v`)
    return v
  }
  
  const i = _whatRangeIndex(origin)
  
  if (i < 0) {
    if (origin - min < 0) {
      return ymin
    }
    if (origin - max > 0) {
      return ymax
    }
    console.error(`[_transferBigDosageBarData]数据v: ${v},不再范围 ${min}~${max}之间`)
  } else {
    const rs = ranges[i]
    const rsGap = rs[1] - rs[0]
    const rw = rangesWidth[i]
    const min = rs[0]
    
    const gap = origin - min
    
    const rst = +yranges[i] + (gap / rsGap) * rw
    
    return +((+rst).toFixed(3))
  }
  
  return +((+rst).toFixed(3)) 
}

export function _heightEquilToBigDosageV(_h = 0) { // 需要修改; y轴 0->10
  const basalYmax = 5
  const h = _h * (ymax / basalYmax) // basal渲染出来的高度，等同于big dosage的y轴渲染出来的2倍高度。因为big dosage y轴ymax是10、basal的ymax是5.
  const i = _whatRangeIndex(h)
  
  if (i >= 0) {
    const threshold = yranges[i]
    const rs = ranges[i]
    const [min, max] = rs
    const gap = max - min
    const rangeW = _rangesWidth[i]
    if (max - h <= 0) {
      console.error(`_heightEquilToBigDosageV入参h: ${h},此入参已经大于允许的最大big dosage max: ${max}.直接返回0`)
      return 0
    }
    const rst = ((h - threshold) / rangeW) * gap + min
    return rst
  } else {
    console.error(`_heightEquilToBigDosageV入参h: ${h},此高度无法算出对应的big dosage的值`)
    return 0
  }
}

export function _basalRateBaseSettingInfosFromValueArray(valueArrayStr = '', fromWhat = '') {
  if (!valueArrayStr) {
    return []
  }
  const values = valueArrayStr.split(',')
  const l = values.length
  const startOfDay = dayjs().startOf('day')
  
  if (l !== 48) {
    error(`${fromWhat}, valueArray没有48个数值, valueArryStr: ${valueArrayStr}`)
  }
  
  if (l <= 0) {
    return []
  }  
  const tmp = values.map((v, i) => {
    const tmp = {
      start: i * 0.5,
      end: (i + 1) * 0.5,
      value: v
    }
    return tmp
  })

  let startI = 0
  
  const rstArr = []
  
  do {
    const first = tmp[startI]
    const rst = qcopy(first)
    const value = first['value']
    let next = tmp[startI + 1]
    let nv = next ? next['value'] : ''

    if (nv && `${nv}`.trim() === `${value}`.trim()) { // 当前和下一个相等
      startI++
      let count = -1
      do {
        // derror(`[do while],value: ${value}, nv: ${nv}, count : ${count}, index: ${startI + count + 1}, startI: ${startI}`)
        rst.end = next.end
        next = tmp[startI + count + 1]
        nv = next ? next['value'] : ''
        count++
      } while (nv && `${nv}`.trim() === `${value}`.trim() && count < 50)
      
      startI += (count - 1)
    }

    // derror(`[do while]before startI++, startI: ${startI}, value: ${value}, nv: ${nv}`)
    rstArr.push(rst)
    startI++
  } while (startI < l)

  // column0, column1

  const tmpRst = rstArr.map(obj => {
    const fmt = 'HH:mm'
    const start = startOfDay.add(obj.start, 'hour').format(fmt)
    let end = startOfDay.add(obj.end, 'hour').format(fmt)

    if (end === '00:00') {
      end = '24:00'
    }
    return {
      column0: `${start}-${end}`,
      column1: `${obj.value}`,
      value: obj.value,
      start: obj.start,
      end: obj.end
    }
  })
  // derror(`tmpRst`, tmpRst)
  return tmpRst
}

export function _createLineAreaWithDiffentColor(data = [], extra = {}) { // 返回的数据，给echarts的series字段使用
  // const cmaxC = 'rgba(240, 189, 90, 0.43)'
  // const cminC = 'rgba(223, 67, 42, 0.43)'
  // const normalC = 'rgba(135, 183, 91, 0.43)'
  
  // const cmaxC = 'rgba(240, 189, 90, 1)'
  // const cminC = 'rgba(223, 67, 42, 1)'
  // const normalC = 'rgba(135, 183, 91, 1)'

  const cmaxC = '#ffaf00'
  const cminC = '#ff0000'
  const normalC = '#70B603'
  
  const fmt = 'YYYY-MM-DD HH:mm:ss'
  const { cmin, cmax, isUnitMg = false } = extra || {}
  derror(`_createLineAreaWithDiffentColor, cmin: ${cmin}, cmax: ${cmax}, data:`, data)
  
  const com = {
    name: 'cmgsArea图',
    type: 'line',
    lineStyle: {
      width: 2,
      type: 'dashed'
    },
    yAxisIndex: 0,
    symbol: 'none',
    smooth: true,
    areaStyle: {
      color: ''
    }
  }
  
  const datac = data.slice() // data每一项 { time, value }
  // step1, 先在data里头，插入一些制造的临界点数据(即，高血糖线临界点、低血糖线临界点)
  const ndata = _insertCriticalPoints(datac) // ndata包含交点信息
  
  // step2,将data分成多段数据(每一个交点，要成为前一段的最后一点、后一段的第一个点)
  const ranges = []  
  const criticalIndexes = []
  ndata.forEach((v, i) => {
    if (v && v.isCritical) {
      criticalIndexes.push(i)
    }
  })
  // debugger
  
  // console.error(`data origin: `, datac)
  
  // console.error(`new data: `, ndata)

  if (criticalIndexes.length) {
    criticalIndexes.sort((a, b) => a - b) // 升序
    // 有交点，需要数据分段
    const _ranges = _getRangesFromArray(ndata, criticalIndexes)
    ranges.push(..._ranges)
  } else { // 没有交点(即没有插入点，就一段数据)
    ranges.push(ndata)
  }
  
  // console.error(`ranges: `, ranges)
  
  const series = []
  
  ranges.forEach((range, rangeI) => {
    const _nC = normalC
    
    const base = qcopy(com) // base config
    base.data = range.map(p => {
      return [
        +dayjs(p.time),
        p.value
      ]
    })
    base.name = `血糖值${rangeI}`
    
    const rl = range.length
    const first = range[0]
    const fv = first['value']
    const ftv = first['truev']
    const fIsCritical = first && first.isCritical // range第一个是临界点
    const last = range[rl - 1]
    const lIsCritical = last && last.isCritical // range最后一个是临界点
    const lv = last['value']
    
    let color = ''
    
    if (rl === 0) {
      console.error(`[range分割有误],当前range: ${JSON.stringify(range)}分割的不对;rangeI: ${rangeI}, ranges: `, ranges)
      return false
    }
    
    if (rl === 1) { // range一个点
      if (isHighGlu(ftv)) {
        color = cmaxC        
      } else if (isLowGlu(ftv)) {
        color = cminC
      } else {
        color = _nC
      }
    } else { // range至少2个点
      if (!fIsCritical && !lIsCritical) {
        // range的第一个和最后一个都不是临界点(临界点就是血糖线和cmin线或cmax线的交点)
        if (isHighGlu(ftv)) {
          // 理论上这个range都是高血糖
          color = cmaxC
          
          // 下面用来报错
          /* eslint-disable */
          do {
            for(let i = 0; i < rl; i++) {
              const tmp = range[i]['value']
              const tmptv = range[i]['truev']
              if (!isHighGlu(tmptv)) {
                // 这个range里头有不是高血糖的血糖值，说明这个range分割有误
                console.error(`[range分割有误],当前tmp: ${tmp}, tmptv: ${tmptv}, range: ${JSON.stringify(range)}分割的不对;rangeI: ${rangeI}, ranges: `, ranges)
                break
              }
            }
          } while(false)
          /* eslint-enable */
        } else if (isLowGlu(ftv)) {
          // 理论上这个range都是低血糖
          color = cminC
          
          // 下面用来报错
          /* eslint-disable */
          do {
            for(let i = 0; i < rl; i++) {
              const tmp = range[i]['value']              
              const tmptv = range[i]['truev']              
              if (!isLowGlu(tmptv)) {
                // 这个range里头有不是低血糖的血糖，说明这个range分割有误
                console.error(`[range分割有误],当前range: ${JSON.stringify(range)}分割的不对;rangeI: ${rangeI}, ranges: `, ranges)
                break
              }
            }
          } while(false)
          /* eslint-enable */   
        } else { // cmin~cmax之间
          // 理论上这个range都是正常血糖
          color = _nC
          
          // 下面用来报错
          /* eslint-disable */
          do {
            for(let i = 0; i < rl; i++) {
              const tmp = range[i]['value']
              const tmptv = range[i]['truev']              
              if (!isNormalGlu(tmptv)) {
                // 这个range里头有非正常范围值的血糖值
                console.error(`[range分割有误],当前range: ${JSON.stringify(range)}分割的不对;rangeI: ${rangeI}, ranges: `, ranges)
                break
              }
            }
          } while(false)
          /* eslint-enable */    
        }
      } else {
        if (fIsCritical) { // range第一个值是临界点(同时最后一个值可能是或者不是临界点)
          const isMax = first && `${first.criticalType}` === 'cmax'
          
          if (isMax) { // cmax临界点
            const second = range[1]
            
            if (second.isCritical) {
              if (rl > 2) {
                console.error(`[range分割有误],当前range: ${JSON.stringify(range)}分割的不对;rangeI: ${rangeI}, ranges: `, ranges)              
              } else { // range里头就2个临界点
                color = _nC
              }
            } else {
              // 第二个数值，不是临界点              
              if (isHighGlu(second.truev)) {
                color = cmaxC
              } else if (isNormalGlu(second.truev)) {
                color = _nC
              } else {
                // 第一个是cmax临界点，其后的点只能是高血糖、或者正常血糖，所以不应该在这个分支(即低血糖)
                console.error(`[range分割有误],当前range: ${JSON.stringify(range)}分割的不对;rangeI: ${rangeI}, ranges: `, ranges)                            
              }
            }
          } else { // cmin的临界点
            const second = range[1]
            
            if (second.isCritical) {
              if (rl > 2) {
                console.error(`[range分割有误],当前range: ${JSON.stringify(range)}分割的不对;rangeI: ${rangeI}, ranges: `, ranges)              
              } else { // range里头就2个临界点
                color = _nC
              }
            } else {
              // 第二个数值，不是临界点
              if (isLowGlu(second.truev)) {
                color = cminC
              } else if (isNormalGlu(second.truev)) {
                color = _nC
              } else {
                // 第一个是cmin临界点，其后的点只能是低血糖、或者正常血糖，所以不应该在这个分支(即高血糖)
                console.error(`[range分割有误],当前range: ${JSON.stringify(range)}分割的不对;rangeI: ${rangeI}, ranges: `, ranges)                            
              }
            }
          }
        } else { // range最后一个值是临界点(并且第一个值不是临界点)
          const lastIsMax = last && `${last.criticalType}` === 'cmax'
          
          if (lastIsMax) { // 最后一个是cmax临界值
            if (isHighGlu(ftv)) {
              color = cmaxC
            } else if (isNormalGlu(ftv)) {
              color = _nC
            } else {
              // 最后一个是cmax临界点，并且第一个点不是临界点，那么第一个点只能是高、或者正常血糖，所以不应该在这个分支(即低血糖)
              console.error(`[range分割有误],当前range: ${JSON.stringify(range)}分割的不对;rangeI: ${rangeI}, ranges: `, ranges)
            }
          } else { // 最后一个是cmin临界值
            if (isLowGlu(ftv)) {
              color = cminC
            } else if (isNormalGlu(ftv)) {
              color = _nC
            } else {
              // 最后一个是cmin临界点，并且第一个点不是临界点，那么第一个点只能是低血糖、或者正常血糖，所以不应该在这个分支(即高血糖)
              console.error(`[range分割有误],当前range: ${JSON.stringify(range)}分割的不对;rangeI: ${rangeI}, ranges: `, ranges)
            }
          }
        }
      }
    }
    
    // console.error(`color: ${color}`)    
    if (color) {
      base.lineStyle.color = color
      // base.areaStyle.color = color // 将area的颜色去掉
    } else {
      console.error(`[逻辑漏洞]竟然算不出来color, 非法的数据段(range), cmax: ${cmax}, cmin: ${cmin}, first: ${JSON.stringify(first)}, last: ${JSON.stringify(last)}`)
    }
    
    // console.error(`base: ${JSON.stringify(base)}`)
    series.push(base)
  })
  // console.log(`series`, series)
  // window.series = series
  // series.map((v, i) => {
  //   console.log(`series[${i}]: ${JSON.stringify(v)}`)
  // })
  return series
  
  function _getRangesFromArray(dataO = [], criticalIndexesO = []) {
    if (_getRangesFromArray._protect === undefined) {
      _getRangesFromArray._protect = 1
    } else {
      _getRangesFromArray._protect++      
    }
    
    if (_getRangesFromArray._protect >= 200) {
      console.error(`_getRangesFromArray,死循环的递归，为了避免内存爆照，直接返回[],进行保护`)
      // reset
      _getRangesFromArray._protect = 1
      return []
    }
    
    const data = dataO.slice()
    const criticalIndexes = criticalIndexesO.slice()
    criticalIndexes.sort((a, b) => a - b) // 升序
    
    if (criticalIndexes.length === 0) {
      // reset
      _getRangesFromArray._protect = 1
      return data.length ? [data] : []
    }
    
    const firstI = criticalIndexes[0]
    
    if (firstI === 0) { // 第一个数据就是临界点
      const secondI = criticalIndexes[1] // 有可能是undefined
      
      if (!secondI) {
        // reset
        _getRangesFromArray._protect = 1
        return [data] // 直接返回data数据，就一个range
      } else { // data这段数据，至少有2个临界点，并且data[0]是第一个临界点
        const firstPart = data.slice(0, secondI + 1) // 又是firstI === 0，所以slice直接0开始
        const secondPart = data.slice(secondI) // 第一个点也是firstPart的最后一个critical点
        
        if (secondPart.length > 1) {
          criticalIndexes.shift() // 去掉第一项,其值为0
          
          // reset
          _getRangesFromArray._protect = 1
          return [firstPart, ..._getRangesFromArray(secondPart, criticalIndexes.map(v => { // 处理后的criticalIndexes的第一项值是0
            return v - secondI
          }))]
        } else {
          // reset
          _getRangesFromArray._protect = 1
          return (firstPart && firstPart.length) ? [firstPart] : []
          // if (secondPart.length === 1) { // data最后一个数据是一个临界点
          //   return (firstPart && firstPart.length) ? [firstPart] : []
          // } else { // 空了
          //   return (firstPart && firstPart.length) ? [firstPart] : []
          // }
        }
      }      
    } else { // 第一个数据不是临界点
      const firstPart = data.slice(0, firstI + 1)
      const secondPart = data.slice(firstI) // 第一个点也是firstPart的最后一个critical点
      
      if (secondPart.length > 1) {
        criticalIndexes.shift() // 去掉第一项,其值为0

        // reset
        _getRangesFromArray._protect = 1
        return [firstPart, ..._getRangesFromArray(secondPart, criticalIndexes.map(v => { // 处理后的criticalIndexes的第一项值是0
          return v - firstI
        }))]
      } else {
        // reset
        _getRangesFromArray._protect = 1
        return (firstPart && firstPart.length) ? [firstPart] : []
        // if (secondPart.length === 1) { // data最后一个数据是一个临界点
        //   return (firstPart && firstPart.length) ? [firstPart] : []
        // } else { // 空了
        //   return (firstPart && firstPart.length) ? [firstPart] : []
        // }
      }
    }    
  }
  
  function _insertCriticalPoints(o = []) {
    if (_insertCriticalPoints._protect === undefined) {
      _insertCriticalPoints._protect = 1
    } else {
      _insertCriticalPoints._protect++      
    }
    
    if (_insertCriticalPoints._protect >= 200) {
      console.error(`_insertCriticalPoints死循环的递归，为了避免内存爆照，直接返回[],进行保护`)
      // reset
      _insertCriticalPoints._protect = 1
      return []
    }//  else {
    //   console.error(`_insertCriticalPoints._protect: ${_insertCriticalPoints._protect}`)
    // }
    
    const orin = o.slice()
    const l = orin.length
    const lIsOdd = l % 2 === 1
    
    if (l <= 1) {
      // reset
      _insertCriticalPoints._protect = 1
      return orin
    }
    
    if (l >= 3) {
      const half = Math.floor(l / 2)
      const firstHalf = orin.splice(0, half)
      const secondHalf = orin
      
      const firstPart = _insertCriticalPoints(firstHalf)
      const secondPart = _insertCriticalPoints(secondHalf)
      
      const middleArr = _insertCriticalPointsBetweenTwoPoints(firstPart[firstPart.length - 1], secondPart[0]) 
      const mc = middleArr.slice()
      // middleArr掐头去尾
      middleArr.splice(0, 1)
      middleArr.pop()
      
      if (middleArr.length) {
        if (firstPart[firstPart.length - 1].time === middleArr[0].time && _getTrueValue(firstPart[firstPart.length - 1]) - middleArr[0].value === 0) {
          derror(`此处应debugger`)
        }
        if (secondPart[0].time === middleArr[middleArr.length - 1].time && _getTrueValue(secondPart[0]) - middleArr[middleArr.length - 1].value === 0) {
          derror(`此处应debugger`)
        } 
      }

      // reset
      _insertCriticalPoints._protect = 1
      return [...firstPart, ...middleArr, ...secondPart]
    }
    
    if (l === 2) {
      const t = _insertCriticalPointsBetweenTwoPoints(orin[0], orin[1])
      // reset 
      _insertCriticalPoints._protect = 1
      return t
    }
    
    function _insertCriticalPointsBetweenTwoPoints(p1 = {}, p2 = {}) {
      const timeOrderAsc = p1 && p2 && ((dayjs(p2['time']) - dayjs(p1['time'])) >= 0)
      
      const start = timeOrderAsc ? p1 : p2
      const end = timeOrderAsc ? p2 : p1
      
      const v0 = _getTrueValue(start)
      const t0 = +dayjs(start['time'])
      const v1 = _getTrueValue(end)
      const t1 = +dayjs(end['time'])
      const timeGap = Math.abs(t1 - t0)
      
      const length = Math.abs(v0 - v1)
      const gap = v0 - v1
      
      const rst = [start, end]
      
      if (!timeOrderAsc) {
        derror(`此处应debugger`)
      }
      if (gap === 0) {
        return rst
      }
      
      if (gap > 0) { // start的值比end的值大
        if (v0 - cmax >= 0 && v1 - cmax <= 0) { // 和cmax线有交点(start的值在cmax之上;end的值在cmax之下)
          // 插入一个cmax的交点到start后面
          const gapCmax = v0 - cmax
          const cmaxP = _setPointObjWithTrueValue(cmax, {
            isCritical: true,
            criticalType: 'cmax',
            time: dayjs(t0 + (gapCmax / length) * timeGap).format(fmt)
          })
          rst.splice(1, 0, cmaxP) // 点插到start后面
        }
        
        if (v0 - cmin >= 0 && v1 - cmin <= 0) { // 和cmin线有交点(end的值在cmin之下;start值在cmin之上)
          // 传输一个cmin的交点到end之前
          const gapCmin = cmin - v1
          const cminP = _setPointObjWithTrueValue(cmin, {
            isCritical: true,
            criticalType: 'cmin',
            time: dayjs(t1 - (gapCmin / length) * timeGap).format(fmt)
          })
          const l = rst.length
          rst.splice(l - 1, 0, cminP) // 点插到end之前
        }
      } else { // start的值比end的值小
        if (v1 - cmax >= 0 && v0 - cmax <= 0) { // 和cmax线有交点(end的值在cmax之上;start的值在cmax之下)
          // 插入一个cmax的交点到end前面
          const gapCmax = v1 - cmax
          const cmaxP = _setPointObjWithTrueValue(cmax, {
            isCritical: true,
            criticalType: 'cmax',
            time: dayjs(t1 - (gapCmax / length) * timeGap).format(fmt)
          })
          const l = rst.length
          rst.splice(l - 1, 0, cmaxP) // 点插到end之前
        }
        
        if (v1 - cmin >= 0 && v0 - cmin <= 0) { // 和cmin线有交点(end的值在cmin之上;start值在cmin之下)
          // 传输一个cmin的交点到start之后
          const gapCmin = cmin - v0
          const cminP = _setPointObjWithTrueValue(cmin, {
            isCritical: true,
            criticalType: 'cmin',
            time: dayjs(t0 + (gapCmin / length) * timeGap).format(fmt)
          })
          rst.splice(1, 0, cminP) // 点插到start之后
        }
      }
      
      // console.error(`_insertCriticalPointsBetweenTwoPoints, rst.length: ${rst.length}, rst: `, rst)
      if (rst.length > 2 && (rst[0].isCritical || rst[rst.length - 1].isCritical)) {
        derror(`此处应debugger`)
      }

      return rst.map(obj => {
        if (obj.isCritical && obj.truev === undefined) {
          obj.truev = obj.value
        }
        return obj
      })
    }
  }

  function _getTrueValue(data) {
    let v = data['truev']
    if (v === undefined) {
      console.error(`[逻辑黑洞]_createLineAreaWithDiffentColor函数，判断关键的交点的时候，入参数据没有truev字段。为了逻辑不崩溃，继续取value字段`)
      v = data['value']
    }
    return v
  }
  
  function _setPointObjWithTrueValue(truev, rest = {}) {
    if (Number.isNaN(+truev)) {
      return rest
    }
    const value = _transferBGData(truev, isUnitMg)
    return {
      ...rest,
      value,
      truev
    }
  }
}

export function _otherDataGetTempBasalFilter(v) {
  return v && `${v.eventPort}` === '0' && +v.eventType === 8
}

export function _otherDataGetTempBasalStopFilter(v) {
  return v && `${v.eventPort}` === '0' && +v.eventType === 10
}

export function _otherDataGetReservoirChangeFilter(v) {
  return v && `${v.eventPort}` === '0' && `${v.eventType}` === '0'
}

export function _otherDataGetModuleChangeFilter(v) {
  return v && `${v.eventPort}` === '0' && +v.eventType === 3
}

export function _otherDataGetPumpClockFilter(v) {
  return v && `${v.eventPort}` === '0' && [1, 2].includes(+v.eventType)
}

export function _otherDataGetTimeZoneFilter(v) {
  return v && `${v.eventPort}` === '0' && +v.eventType === 2
}
export function _otherDataGetTimeChangeFilter(v) {
  return v && `${v.eventPort}` === '0' && +v.eventType === 1
}

export function _isTempBasalVersion2(record) { // 即，此版本的临时基础率数据里头有持续时间;
  // 版本1里头，临时基础率没有持续时间
  let rst = false
  if (record && record.eventValue) {
    rst = true
  }
  return rst
}

export function _isTempBasalVersion2Percent(record) {
  // 版本1里头，临时基础率没有持续时间
  let rst = false
  if (record) {
    const s = `${record.statusByte0}`.trim()
    // if (['1', '2'].includes(s)) {
    if (['2'].includes(s)) {
      rst = true
    }
  }

  return rst
}

export function _getTempBasalDurationVersion2(record) { // 即，此版本的临时基础率数据里头有持续时间; 返回值的单位是小时
  // 版本1里头，临时基础率没有持续时间
  const isVersion2 = _isTempBasalVersion2(record)
  if (isVersion2) {
    const v = record && record.eventValue
    return v / 10
  } else {
    return 0
  }
}

export function _getTempBasalVersion2Percent(record) { // 返回549代表549%
  const pass = _isTempBasalVersion2(record) && _isTempBasalVersion2Percent(record)
  if (pass) {
    const v = record.statusShort1
    
    return v
  }
  return -1
}

export function _getDeadlineGaps(pumpRecord = [], basalRateInfoMsg = []) {
  let rst = []
  const fmt = 'YYYY-MM-DD HH:mm:ss'
  
  const _basals = _getPumpBasalFromRecords(pumpRecord)
  derror(`_getDeadlineGaps, pumpRecord: `, pumpRecord)
  derror(`_getDeadlineGaps, _basals: `, _basals.map(v => [dayjs(v[0]).format(fmt), v[1]]))
  const basalNotZeros = _basals.filter(v => !!v[1])
  const basalHasZeroInNounZeroGaps = []
  
  for (let i = 0; i < (basalNotZeros.length - 1); i++) {
    const $start = +dayjs(basalNotZeros[i][0])
    const $end = +dayjs(basalNotZeros[i + 1][0])
    
    // 判断i那一项和i+1那一项之间，没有值为0的基础率
    if (!_basals.every(v => { // 每一项0值的时间戳，都不在i和i+1的时间戳之间
      const t = +dayjs(v[0])
      const value = v[1]
      if (value) { // 非零值，跳过
        return true
      }
      const notInGap = (!(t - $start >= 0 && t - $end <= 0)) && (!(t - $end >= 0 && t - $start <= 0))
      return notInGap
    })) {
      // i和i+1之间，有至少一个值为0的基础率, 所以将其i和i+1保存起来
      const gap = [basalNotZeros[i], basalNotZeros[i + 1]]
      basalHasZeroInNounZeroGaps.push(gap)
    }
  }
  derror(`[_getDeadlineGaps]_basals`, _basals.map(v => [dayjs(v[0]).format(fmt), v[1]]))
  derror(`[_getDeadlineGaps]basalNotZeros`, basalNotZeros.map(v => [dayjs(v[0]).format(fmt), v[1]]))
  derror(`[_getDeadlineGaps]basalHasZeroInNounZeroGaps`, (basalHasZeroInNounZeroGaps.map((v) => {
    const s = v[0]
    const e = v[1]
    return [[...s, dayjs(s[0]).format(fmt)], [...e, dayjs(e[0]).format(fmt)]]
  })))
  
  // 生成基础率红线的series
  const notZeroGapNum = basalHasZeroInNounZeroGaps.length
  if (notZeroGapNum > 0) {
    if (basalRateInfoMsg.length) {            
      const gaps = []
      derror(`basalRateInfoMsg, `, qcopy(basalRateInfoMsg))
      // 开始基础率红线
      for (let i = 0; i < notZeroGapNum; i++) {
        const gap = basalHasZeroInNounZeroGaps[i]
        const $start = +dayjs(gap[0][0])
        const $end = +dayjs(gap[1][0])
        
        if (!basalRateInfoMsg.every(v => { // 判断每一个产生的'错误信息'，都不在这个$start-$end的时间范围内
          const t = +dayjs(v.dateTimeStr)
          const inGap = (t - $start <= 0 && t - $end >= 0) || (t - $start >= 0 && t - $end <= 0)
          const notInGap = !inGap
          return notInGap
        })) {
          // 当前gap有产生错误信息，即认为需要画红线
          const i = findObjIndexInArray(_basals, [$start], _sameTime)
          
          if (i < 0) {
            error(`获取基础率时间戳为${$start}，并且基础率不为空的数据的下标失败,那么这一个gap无法产生(即不画红线)`)
          } else {
            if (i + 1 >= _basals.length) {
              error(`获取基础率时间戳为${$start}，并且基础率不为空的数据的下标的值为: ${i},而_basals.length为: ${_basals.length},意味着这个数据要么溢出、要么是数组最后一个,那么这一个gap无法产生(即不画红线)`)
            } else {
              // 合法的gap(红线)
              const next = _basals[i + 1]
              const ns = +dayjs(next[0])
              gaps.push([ns, $end])
            }
          }
        }
      }
      derror(`需要画红线的gaps`, gaps.map(v => [dayjs(v[0]).format(fmt), dayjs(v[1]).format(fmt)]))
      rst = gaps
    } else {
      error(`basalHasZeroInNounZeroGaps只有${basalHasZeroInNounZeroGaps.length}条记录，少于1条，所以我们不计算'基础率红线了'`)
    }
  }
  return rst
  function _sameTime(v, compareToMeArr) {
    let same = false
    const [v1, v2, ...rest] = compareToMeArr
    
    if (v && v[0] && v1) {
      same = +dayjs(v[0]) === +dayjs(v1)
    }
    
    return same
  }
}

export function _tempBasalDuration(secondNum = 0, show2Seconds = false, i18nTexts = {
  hour: 'h',
  min: 'm',
  second: 's'
}) {
  const hour = Math.floor(secondNum / 3600)
  const minutes = Math.floor((secondNum - hour * 3600) / 60)
  const seconds = secondNum - (Math.floor(secondNum / 60) * 60)
  const lessThan1Min = secondNum - 60 <= 0

  if (lessThan1Min) {
    let rst = ''
    // 少于一分钟，直接返回秒
    if (seconds) {
      rst = `${rst}${padZero(seconds.toFixed(0))}${i18nTexts.second}`
    }
    return rst
  } else {
    // 超过1分钟，直接省略秒
    
    if (hour - 1 >= 0) {
      // 超过1小时
      if (minutes === 0) {
        return `${padZero(hour)}${i18nTexts.hour}`
      } else {
        const mins = ((secondNum - hour * 3600) / 60).toFixed(0)
        // console.error(`mins: ${mins}`)

        if (`${mins}` === '60') {
          // 59分30秒+，最后会toFixed(0)显示成60分
          // mins = ''
          return `${padZero(hour + 1)}${i18nTexts.hour}`
        } else {
          return `${padZero(hour)}${i18nTexts.hour}${padZero(mins)}${i18nTexts.min}`        
        }
      }
    } else {
      // 一小时不到
      const mins = (secondNum / 60).toFixed(0)
      return `${padZero(mins)}${i18nTexts.min}`
    }
  }
  
  // if (show2Seconds) {
  //   let rst = ''
  //   if (hour) {
  //     rst = `${padZero(hour)}${i18nTexts.hour}`
  //   }
  //   if (minutes) {
  //     rst = `${rst}${padZero(minutes)}${i18nTexts.min}`
  //   }
  //   if (seconds) {
  //     rst = `${rst}${padZero(seconds.toFixed(0))}${i18nTexts.second}`
  //   }
  //   return rst
  // }
  
  // if (hour - 1 >= 0) {
  //   if (minutes === 0) {
  //     return `${padZero(hour)}${i18nTexts.hour}`
  //   } else {
  //     const mins = ((secondNum - hour * 3600) / 60).toFixed(0)
  //     // console.error(`mins: ${mins}`)

  //     if (`${mins}` === '60') {
  //       // 59分30秒+，最后会toFixed(0)显示成60分
  //       // mins = ''
  //       return `${padZero(hour + 1)}${i18nTexts.hour}`
  //     } else {
  //       return `${padZero(hour)}${i18nTexts.hour}${padZero(mins)}${i18nTexts.min}`        
  //     }
  //   }
  // } else {
  //   // 一小时不到
  //   // 精确到秒
  //   if (minutes === 0) {
  //     return `${padZero(seconds.toFixed(0))}${i18nTexts.second}`
  //   } else {
  //     const mins = +minutes
  //     const ss = seconds.toFixed(0)
  //     // console.error(`ss: ${ss}`)
  //     if (`${ss}` === '60') {
  //       return `${padZero(mins + 1)}${i18nTexts.min}`
  //     } else {
  //       return `${padZero(mins)}${i18nTexts.min}${padZero(ss)}${i18nTexts.second}`        
  //     }
  //   }
  // }
}

export function _evenEventIcons(rst = [], _earliest = 0, gap = 900) { // gap: 单位秒
  const earliest = +dayjs(_earliest)
  // 从后往前推
  const l = rst.length
  let i = l - 1

  for (;i >= 0; i--) {
    const before = rst[i - 1]
    if (before) {
      const cur = rst[i]
      const curT = cur[0]
      const bT = before[0]
      if (curT - bT <= gap * 1000) {
        // 修改before的时间
        let nbT = curT - gap * 1000
        if (nbT < earliest) {
          nbT = earliest
        }
        before[0] = nbT
      }
    }
  }
  
  return rst
}

export function _evenVerticalDashLine(rst = [], _earliest = 0, {
  gap = 1500, lfs
}) { // gap: 单位秒
  // 要将其错开
  const earliest = +dayjs(_earliest)
  // 从后往前推
  const l = rst.length
  let i = l - 1  

  for (;i >= 0; i--) {
    const before = rst[i - 1]
    if (before) {
      const cur = rst[i]
      const curT = +dayjs(cur['xAxis'])
      const bT = +dayjs(before['xAxis'])
      if (curT - bT <= gap * 1000) {
        const oldH = cur.label.distance[1]
        if (!lfs && !cur.changed) {
          lfs = oldH / 0.5
        }
        const br = 0.05 // bottom ratio
        const tr = 0.95 // top ratio
        // 正常下标是0.5 * lfs
        // 需要错开
        if (cur.changed === undefined) {
          // cur没有变换过
          // cur需要变换成向上位移一点;before需要改成bottom
          cur.changed = 'top'
          cur.label.distance[1] = tr * lfs
          before.changed = 'bottom'
          before.label.distance[1] = br * lfs
        } else {
          // cur已经变换过
          const cc = cur.changed
          if (cc === 'top') {
            // before需要变成bottom
            before.changed = 'bottom'
            before.label.distance[1] = br * lfs            
          } else {
            // before需要变成top
            before.changed = 'top'
            before.label.distance[1] = tr * lfs
          }
        }
        
        // // 修改before的时间
        // let nbT = bT - gap * 1000 * 0.3
        // if (nbT < earliest) {
        //   nbT = earliest
        // }
        // before['old'] = dayjs(bT).format('YYYY-MM-DD HH:mm:ss')
        // before['xAxis'] = nbT
        // before['achanged'] = true

        // // 修改current的时间
        // const nct = curT + gap * 1000 * 0.3
        // cur['xAxis'] = nct
      }
    }
  }

  rst.forEach(cfg => { cfg.axAxis = dayjs(cfg.xAxis).format('YYYY-MM-DD HH:mm:ss') })
  // console.error(`event rst`, {
  //   rst
  // })
  return rst
}

export function bolusDetailNeedSplitColumnNum(lang = 'en') {
  let d // 超过d条记录要分页

  /* eslint-disable */
  switch(`${lang}`) {
  case 'en':
    d = 13
    break
  case 'es': // 西班牙语Carbs Ratio Setting会显示成3行，所以再宽一点
    d = 13
    break
  case 'cs': // 捷克语再宽一点
  default:
    d = 13    
    break
  }
  /* eslint-enable */
  return d
}

export function _splitBolusDetailDataToTwoPages(_pumpLegalDailyList = [], extra = {}) {
  const { bigDosageMinWidthMinutes = 15, lang = 'en' } = extra
  const rst = []
  const needSplitNum = bolusDetailNeedSplitColumnNum(lang) // 超过bolusDetailNeedSplitColumnNum条记录要分页

  _pumpLegalDailyList.forEach(v => {
    const value = deepClone(v)
    const { threeChartData = {}} = value
    const { insulinChart = {}} = threeChartData
    const { list2: pumpRecord } = insulinChart
    // const bigDosageMinWidthMinutes = 15 // 这个值变了，也要修改ChartDailyPump里头写死的值
    const bigDosage = _getPumpBigDosageFromRecords(pumpRecord, bigDosageMinWidthMinutes)
    const _rst = _getMergedPumpBigDosageFromRecords(bigDosage, bigDosageMinWidthMinutes)
    const rl = _rst.length

    if (rl > needSplitNum) {
      // 分页
      // 先插入第一页
      rst.push(value)

      // 再插入第二页
      const page2 = deepClone(v)
      page2.bolusDetailFullPage = 1 // 这个标识位一定要有

      const threeChartData = page2.threeChartData || {}
      const insulinChart = threeChartData.insulinChart || {}
      insulinChart.list2 = (deepClone(_rst)).splice(needSplitNum) // 后needSplitNum条的数组
      rst.push(page2) // 插入第二页
    } else {
      rst.push(value)
    }
  })
  
  /* ++++++++++test,dev,mock++++++++++ */
  const pumpLegalDailyList = deepClone(_pumpLegalDailyList)
  for (let ti = 0; ti < _pumpLegalDailyList.length; ti++) {
    const oneday = _pumpLegalDailyList[ti]
    const tmp = deepClone(oneday)
    tmp.bolusDetailFullPage = 1
    
    const { threeChartData = {}} = tmp
    const { insulinChart = {}} = threeChartData
    const { list2: pumpRecord } = insulinChart
    const bigDosageMinWidthMinutes = 15 // 这个值变了，也要修改ChartDailyPump里头写死的值

    const nlist2 = []
    for (let i = 0; i < 6; i++) {
      nlist2.push(...deepClone(pumpRecord))
    }
    insulinChart.list2 = nlist2
    pumpLegalDailyList.push(tmp) // 新插入这个假的天数: tmp.bolusDetailFullPage = 1
  }
  /* ++++++++++End of test,dev,mock++++++++++ */
  return rst
}
